
import React, {Component} from 'react';
import { Button, Row, Col } from 'react-bootstrap'
import { findDOMNode } from 'react-dom'
import { Box } from 'reactjs-admin-lte'
import FontAwesome from 'react-fontawesome'
import Chart from 'chart.js';
import 'chartjs-plugin-datalabels';
import { momentHelper } from '../report/helpers'
import SelectDate from 'component/element/SelectDate'
import IframeModal from 'component/element/IframeModal'
import './Hr.css'
import HrStore from 'stores/HrStore';
import {Checkbox} from 'react-icheck'
const WHOLE_YEAR = momentHelper.getMonth()
class EmployeeWorkMonthlyReport extends Component {

  constructor(...args){
    super(...args)
    this.state = {
      loading:false,
      // data:{
      //   absence:{sick:0,business:0,disappear:0},
      //   task:{total_task:0,open_task:0,close_task:0},
      //   count_office_work:0,
      //   count_actutal_work:0,
      //   task_list:[],
      //   task_employee_allyear:{task_value:[]},
      //   total_refixed:0,
      //   total_overlimit:0,
      //   refixed_duration:0,
      //   task_overall_company:[],
      //   profile:{}
      // },
      data:[],
      month:WHOLE_YEAR,
      year:momentHelper.getYear(),
      showBar:true
    }
    
    this.canvasPieChartRef = []
    // this.canvasPieChartRef2 = []
    this.canvasBarChartRef = []
  }

  componentDidMount() {
    this.loadData(this.state.year,this.state.month)
  }

  loadData(year,month) {
    this.setState({loading:true})
    HrStore.loadMechanicWorkMonthlyStat(year,month,this.props.em,(result)=>{
      this.setState({loading:false,data:result.data})
      result.data.forEach((item,index)=>{
        if (item.task_employee_allyear.task_value.length>0)
          this.setChart(item,index)
        if (item.task_list.length>0)
          this.setPieChart(item,'task_list','task_overall_company',index,this.canvasPieChartRef) 
        // if (item.task_list_quarter.length>0)
        //   this.setPieChart(item,'task_list_quarter','task_overall_company_quarter',index,this.canvasPieChartRef2)
      })    
    })
  }

  getNewValue(number) {
    return new Array(number).fill(null).map((item,index)=>{
      return 0
    })
  }

  setDataBarChart(findMonth,barChartObj) {
    let datasets = []
    let _datasets = []
    let i = 0
    barChartObj.task_value.forEach((item,index)=>{
      let openTotal = this.getNewValue(findMonth.length)
      let closeTotal = this.getNewValue(findMonth.length)
      let max = 300
      let min = 100
      let green = Math.floor(Math.random() * (max - min + 1)) + min
      let bg = "rgb(0," + green + ",0)"
      _datasets.push({
        label: 'เสร็จงาน ('+item+') ',
        task_value: item,
        task_type: 'close',
        backgroundColor: bg,
        stack:index,
        data:[]
      },
      {
        label: 'ค้างงาน ('+item+') ',
        task_value: item,
        task_type: 'open',
        backgroundColor: '#d2d6de',
        stack:index,
        data:[]
      })
      barChartObj[item].sort(function(a, b) {
        if(a['month'] < b['month']) return -1;
        if(a['month'] > b['month']) return 1;
        return 0;
      })
      barChartObj[item].forEach((sitem,sindex)=>{
        closeTotal[i] = sitem.close_task
        openTotal[i] = sitem.open_task
        i++
      })  
      _datasets[0].data = closeTotal
      _datasets[1].data = openTotal
      datasets = datasets.concat(_datasets)
      _datasets = []
      i = 0
    })
    return datasets
  }

  setChart(allData,indexs) {
    this.canvasBar = findDOMNode(this.canvasBarChartRef[indexs]);
    this.ctxBar = this.canvasBar.getContext('2d');
    let canvasBar = this.canvasBar,ctxBar=this.ctxBar
    ctxBar.clearRect(0, 0, canvasBar.width, canvasBar.height);

    let textM = ['ม.ค','ก.พ','มี.ค','เม.ย','พ.ค','มิ.ย','ก.ค','ส.ค','ก.ย','ต.ค','พ.ย','ธ.ค']
    let labels = []
    let findMonth = []
    let barChartObj = allData.task_employee_allyear 

    barChartObj.task_value.forEach((item,index)=>{
      barChartObj[item].forEach((sitem,sindex)=>{
        if (findMonth.indexOf(sitem.month)===-1) {
          findMonth.push(sitem.month)
        }  
      })
    })
    findMonth.forEach((mItem,mIndex)=>{
      labels.push(textM[(mItem-1)*1])
    })
    
    let datasets = this.setDataBarChart(findMonth,barChartObj)
    new Chart(ctxBar, {
      type: 'bar',
      data: {
        labels: labels,
        datasets: datasets
      },
      options: {
        responsive: true, 
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            stacked: true,
            ticks: {
              beginAtZero: true,
              userCallback: function(label, index, labels) {
                  if (Math.floor(label) === label) {
                      return label;
                  }

              },
            }
          }],
          xAxes: [{
            stacked: true,
            ticks: {
              beginAtZero: true
            }
          }]

        },
        legend: {
          display: true
        },
        plugins: {
          datalabels: {
            color: 'black',
						display: function(context) {
							return context.dataset.data[context.dataIndex] > 0
						},
						font: {
              weight: 'bolder',
              size: 18
						},
						formatter: Math.round
          }
        }
      }
    });
  }

  setPieChart(allData,field,field2,indexs,canvasChartRef) {
    allData[field].forEach((item,index)=>{
      this.canvasPie = findDOMNode(canvasChartRef[indexs][index]);
      this.ctxPie = this.canvasPie.getContext('2d');
      let canvasPie = this.canvasPie,ctxPie=this.ctxPie
      ctxPie.clearRect(0, 0, canvasPie.width, canvasPie.height);

      let data = [0,0]
      let findKey = allData[field2].findIndex(x=>x.task_value===item.task_value)
      if (findKey!==-1) {
        data[0] = item.total_task
        data[1] = allData[[field2]][findKey].total_task-item.total_task
      }
      let pieChartObj = {
        datasets: [{
          data:data,
          backgroundColor:['#6ab860','#98b6d8']
        }],
        labels: ['จำนวนงานที่รับผิดชอบ','งานช่างอื่นๆ']
      }
      new Chart(ctxPie, {
        type: 'pie',
        data: pieChartObj,
        options: {
          legend: {
            display: true,
          },
          plugins: {
            datalabels: {
              color: 'black',
              font: {
                weight: 'bolder',
                size: 18
              },
              formatter: (value, ctx) => {
                let sum = 0;
                let dataArr = ctx.chart.data.datasets[0].data;
                dataArr.map((item,index)=>{
                  sum += (item*1);
                });
                let percentage = (value*100 / sum).toFixed(2)+"%";
                return value+' งาน ('+percentage+')';
              }
            }
          },
        }
      });
    })
  }

  onMonthChange(val) {
    this.setState({
      month: val.value
    })
    this.loadData(this.state.year,val.value)
  }

  onYearChange(val) {
    this.setState({
      year: val.value
    })
    this.loadData(val.value,this.state.month)
  }

  onPrintClick() {
    let {showBar} = this.state
    let url = ''
    if (process.env.NODE_ENV === "development") {
      url = './?startPage=PrintEmployeeWorkMonthlyReport&year='+this.state.year+'&month='+this.state.month+'&em='+this.props.em+'&show_bar='+showBar
    } else{
      url = './pdf/v2/?startPage=PrintEmployeeWorkMonthlyReport&year='+this.state.year+'&month='+this.state.month+'&em='+this.props.em+'&show_bar='+showBar
    }
    this.refs.iframe.loadUrl(url) 
  }

  onCheck() {
    let {showBar} = this.state
    if (showBar)
      showBar = false
    else
      showBar = true  
    this.setState({showBar:showBar})
  }

  renderDoc(data) {
    return(
            <Row>              
              <Col md={12}>
                <table className='table' style={{marginBottom:'0'}}>
                  <tbody>
                    <tr>
                      <td style={{width:'140px'}} className='td-title'>รหัสพนักงาน : </td>
                      <td style={{width:'100px'}} className='td-data'>&nbsp;{data.profile.employee_id}</td>
                      <td style={{width:'140px'}} className='td-title'>ชื่อ : </td>
                      <td colSpan={3} className='td-data'>&nbsp;{data.profile.title}{data.profile.first_name} {data.profile.last_name} ({data.profile.nick_name})</td>
                    </tr>
                    <tr>
                      <td className='td-title'>แผนก : </td>
                      <td className='td-data'>&nbsp;{data.profile.department}</td>
                      <td className='td-title'>ตำแหน่ง : </td>
                      <td className='td-data' colSpan={3}>&nbsp;{data.profile.position}</td>
                    </tr> 
                    <tr>
                      <td className='td-title'>มาทำงานกี่วัน : </td>
                      <td className='td-data'>&nbsp;{data.count_office_work} วัน</td>
                      <td className='td-title'>ลางาน : </td>
                      <td className='td-data' style={{width:'90px'}}>&nbsp;ลากิจ {data.absence.business} วัน</td>
                      <td className='td-data' style={{width:'90px'}}>ลาป่วย {data.absence.sick} วัน</td>
                      <td className='td-data' style={{width:'90px'}}>ขาด {data.absence.disappear} วัน</td>
                    </tr> 
                    <tr>
                      <td className='td-title'>งานที่รับผิดชอบ : </td>
                      <td className='td-data'>&nbsp;{data.task.total_task} รายการ</td>
                      <td className='td-title'>ผลงาน : </td>
                      <td className='td-data' colSpan={2}>&nbsp;เสร็จงาน {data.task.close_task} รายการ</td>
                      <td className='td-data' style={{width:'90px'}}>เหลือ {data.task.open_task} รายการ</td>
                    </tr>
                    <tr>
                      <td className='td-title'>จำนวนงานแก้ไข : </td>
                      <td className='td-data'><span className={data.total_refixed>0?'text-red':''}>&nbsp;{data.total_refixed}</span> รายการ</td>
                      <td className='td-title'>จำนวนงานเกินเวลา : </td>
                      <td className='td-data' colSpan={3}><span className={data.total_overlimit>0?'text-red':''}>&nbsp;{data.total_overlimit}</span> รายการ</td>
                    </tr>
                    <tr>
                      <td className='td-title'>จำนวนระยะเวลาแก้ไข : </td>
                      <td className='td-data'><span className={data.refixed_duration>0?'text-red':''}>&nbsp;{data.refixed_duration}</span> วัน</td>
                      <td className='td-title'></td>
                      <td className='td-data' colSpan={3}></td>
                    </tr>
                  </tbody>
                </table>
              </Col>              
            </Row>
    )
  }  

  renderPieChart(data,field,indexs,canvasChartRef) {
    return(
            <div className='text-center' style={{width:'100%'}}>
              {data[field].length===0?
              <div className='text-center'><h3>ไม่พบข้อมูลกราฟพาย</h3></div>
              :data[field].map((item,index)=> {
              canvasChartRef[indexs] = []
              return(  
              <div className='text-center' key={index} style={{display:'inline-block',width:'300px',maxWidth:'300px',margin:'0 auto'}}>
                {item.task_value}
                <div className='text-center'>
                  <div className='text-center'>
                    <canvas 
                      ref={(canvas) => { canvasChartRef[indexs][index] = canvas; }}
                      width="100" 
                      height="100"
                    >
                    </canvas>
                  </div>
                </div>
              </div>  
              )})}
            </div>
    )
  }

  renderBarChart(items,indexs) {
    let {showBar} = this.state
    return(
            
              <div style={{display:(showBar?'':'none')}} className='text-center'>
                {items.task_employee_allyear.task_value.length>0?
                <div className='text-center' style={{maxWidth:'1280px',maxHeight:'400px',height:'400px',margin:'0 auto'}}>
                  <canvas 
                    ref={(canvas) => { this.canvasBarChartRef[indexs] = canvas; }}
                    width="100" 
                    height="100"
                  >
                  </canvas>
                </div>
                :<h3>ไม่พบข้อมูลกราฟแท่ง</h3>}
                <br />
              </div>
    )
  }

  renderToolbar() {
    return(
          <SelectDate
            wholeYear={true}
            year={this.state.year}
            month={this.state.month}
            onMonthChange={this.onMonthChange.bind(this)}
            onYearChange={this.onYearChange.bind(this)}
          />
    )
  }

  renderChartTitle(title) {
    return(
              <table className='table' style={{marginBottom:'0'}}>
                <tbody>
                  <tr>
                    <td style={{fontWeight:'bolder'}}>{title}</td>
                  </tr>
                </tbody>        
              </table>
    )
  }

  getDate() {
    let {year,month} = this.state
    let text = 'รายงานสรุปการทำงานของพนักงานประจำเดือน '
    if (month===''||month==='0'||month==='00') {
        text = 'รายงานสรุปการทำงานของพนักงานประจำปี '+year
    } else {
        text += momentHelper.getMonthText(month)+' '+year    
    }
    return text
  }

  render(){
    let {data,showBar} = this.state
    return (
      <div className='emp-work-monthly-report'>
        <Box loading={this.state.loading}>
          <Box.Header className='text-center' border={true}>
            <Box.Title>
              สรุปการทำงานของพนักงาน <span className='text-left'>{this.renderToolbar()}</span>
              <div className='text-center'>
                <Checkbox 
                  checkboxClass="icheckbox_square-blue"
                  increaseArea="20%"
                  label={' การทำงานทั้งปี'}
                  checked={showBar}
                  onChange={this.onCheck.bind(this)}
                />  
              </div> 
            </Box.Title>
            <Box.Tools>
              <Button onClick={this.onPrintClick.bind(this)} bsStyle='danger'>
                <FontAwesome name='print' /> พิมพ์เอกสาร
              </Button>
            </Box.Tools>
          </Box.Header>
          <Box.Body>
          {data.length===0
            ?<h4 className='text-center'>ไม่พบข้อมูล</h4>
            :''}
            {data.length===0
            ?''
            :data.map((item,index)=>
            <div key={index} style={{maxWidth:'21cm',margin:'0 auto'}}>
              <h4 className='text-center'>{this.getDate()}</h4>
              {this.renderDoc(item)}
              <br />
              {this.renderChartTitle('การทำงานประจำเดือน (% ต่อองค์กร)')}
              {this.renderPieChart(item,'task_list',index,this.canvasPieChartRef)}
              <br />
              {/* {this.renderChartTitle('การทำงานประจำไตรมาส (% ต่อองค์กร)')}
              {this.renderPieChart(item,'task_list_quarter',index,this.canvasPieChartRef2)}
              <br /> */}
              {showBar?
              this.renderChartTitle('การทำงานประจำเดือนโดยเฉลี่ยเป็น')
              :''}
              {this.renderBarChart(item,index)}
            </div>)}
          </Box.Body>
        </Box>
        <IframeModal ref='iframe' title={'พิมพ์เอกสาร'} />  
      </div>
    )
  }
}

export default EmployeeWorkMonthlyReport;





// WEBPACK FOOTER //
// ./src/view/hr/EmployeeWorkMonthlyReport.js